// for next.js server-component 执行

let Hammer: typeof import("hammerjs") | null = null;

let hammerLoading: Promise<typeof import("hammerjs")> | null = null;

function loadHammer() {
  if (Hammer) {
    return Promise.resolve(Hammer);
  }
  if (!hammerLoading) {
    hammerLoading = import("hammerjs").then((mod) => {
      Hammer = mod.default ?? mod;
      return Hammer;
    });
  }
  return hammerLoading;
}

export function createGesture(el: HTMLElement) {
  return new Gesture(el);
}

class Gesture {
  private instance: any = null;
  private pending: any[] = [];

  constructor(private el: HTMLElement) {
    this.load();
  }

  private async load() {
    const Hammer = await loadHammer();
    this.instance = new Hammer(this.el);
    this.pending.forEach(([event, cb]) => {
      this.instance.on(event, cb);
    });
    this.pending = [];
  }

  on(event: string, cb: (e: any) => void) {
    if (this.instance) {
      this.instance.on(event, cb);
    } else {
      this.pending.push([event, cb]);
    }
  }

  off(event: string, cb: (e: any) => void) {
    this.instance?.off(event, cb);
  }

  destroy() {
    this.pending = [];
    this.instance?.destroy();
    this.instance = null;
  }
}
